const DEFAULT_HTTP_RECORDER_ENTITY_IDS = [
  "120",
  "47",
  "140",
  "49",
  "141",
  "50086",
];

const configuredEntityIds = String(
  process.env.REACT_APP_HTTP_RECORDER_ENTITY_IDS || "",
)
  .split(",")
  .map((entityId) => entityId.trim())
  .filter(Boolean);

export const HTTP_RECORDER_ENTITY_IDS = Object.freeze(
  configuredEntityIds.length
    ? configuredEntityIds
    : DEFAULT_HTTP_RECORDER_ENTITY_IDS,
);

const allowedHttpRecorderEntityIds = new Set(HTTP_RECORDER_ENTITY_IDS);

export function canUseHttpRecorder(entityId) {
  return allowedHttpRecorderEntityIds.has(String(entityId || "").trim());
}
